// extracted by mini-css-extract-plugin
var _1 = "xigvYZ6FOPuzyq0e5NC4";
var _2 = "Yi4Kfu2FAVFdS26WARNg";
var _3 = "wONpycdNFz86tRcU6C_m";
var _4 = "qkFuCXZbUtyjVeXc92dv";
var _5 = "BjP8WZiXO4do8jcpztl0";
var _6 = "hVusUH9cwbPMucqYUQAo";
var _7 = "pizTowimUEWutJ0MuFkM";
var _8 = "qXaMKzwN3Bc5bgC6PtQU";
var _9 = "bB9z4ZZ8qsg4dvbhmszD";
var _a = "ZBm6SkpNmcWIgsk1v4sU";
var _b = "nlyzWNNp8y2ptU7a4s3F";
var _c = "KsFEtc38UuEbamJn77yA";
var _d = "PTS7DpzH5OxeM5TBfagZ";
var _e = "l0BxSyZVJ_pWI0m3G4vb";
var _f = "eIXCiXrnrTCiX_EZfqrX";
var _10 = "zMpHvQ_qh0t9jTU2J4lx";
var _11 = "GrNRwevFWn2e15qJSHXm";
var _12 = "NFsZkhIDP4WjtIc7ohyT";
var _13 = "yuXzFH1CNT9rGrCtbjIw";
var _14 = "LikaIBXQHIV5ds5BGjkp";
var _15 = "PUI9zmmsD0h5Knr36zip";
var _16 = "Z92YwfSoEK5j2NmgMR8r";
var _17 = "kSgzKd_93lOcbG82NGB0";
var _18 = "c4CKrLtHvuYIOLCpKA6E";
export { _1 as "alert", _2 as "alertHeading", _3 as "danger", _4 as "info", _5 as "is-128x128", _6 as "is-16x16", _7 as "is-24x24", _8 as "is-32x32", _9 as "is-48x48", _a as "is-64x64", _b as "is-96x96", _c as "success", _d as "theme-cardiology", _e as "theme-dermatology", _f as "theme-empty", _10 as "theme-lab", _11 as "theme-mentalHealth", _12 as "theme-ophthalmology", _13 as "theme-pulmonology", _14 as "theme-referall", _15 as "theme-sleep", _16 as "theme-white-theme", _17 as "theme-xyz", _18 as "warning" }
